import { Prop, Component, h } from "@stencil/core";
import classNames from "classnames";

/**
 * @name        a-divider
 * @type        divider
 *
 * @param   {boolean} withMargin  top and bottom margin when divider placed within text paragraphs
 * @param   {boolean} vertical    displays divider as vertical line
 *
 * @description
 * representation of dividers
 */
@Component({
  tag: "f-divider",
})
export class Divider {
  @Prop() withMargin: boolean;
  @Prop() vertical: boolean;

  render() {
    //TODO: report to FROK naming convention of classes is very misleading
    const dividerClass = classNames("a-divider", {
      [`-within-text`]: this.withMargin,
      [`a-divider--vertical`]: this.vertical,
    });
    return <hr class={dividerClass} />;
  }
}
